let currentYear = null;
let currentMonth = null;

export function onDateChange() {
    const yearSelect = document.getElementById("yearSelect");
    const monthSelect = document.getElementById("monthSelect");
    const userSelectContainer = document.getElementById('userSelectContainer');
    const userSelect = document.getElementById('userSelect');
    const generateBtn = document.getElementById('generateReportBtn');
    const tableBody = document.getElementById("tablebody");

    const selectedYear = yearSelect.value;
    const selectedMonth = monthSelect.value;

    // Проверяем, изменился ли период
    if (selectedYear !== currentYear || selectedMonth !== currentMonth) {
        // Если период изменился, очищаем таблицу
        tableBody.innerText = '';
        currentYear = selectedYear;
        currentMonth = selectedMonth;
    }

    if (selectedYear !== "0" && selectedMonth !== "0") {
        // получение списка пользователей
        new SendData({
            data: {
                year: selectedYear,
                month: selectedMonth,
            },
            messageAuto: true,
            url: Redirect.route('monthRaportUsers')
        }).then(response => {
            userSelect.innerHTML = '';

            // Преобразуем объект в массив значений
            const users = Object.assign(response.answer);
            if (users.length > 1) {
                users.forEach(user => {
                    const option = document.createElement('option');
                    option.value = user.id;
                    option.textContent = user.name;
                    userSelect.appendChild(option);
                });
                userSelectContainer.classList.remove('user-select-hidden');
                userSelectContainer.classList.add('d-flex');
                generateBtn.disabled = false;

                MessageManager.showMessage({
                    type: 'success',
                    text: 'Список сотрудников загружен',
                });
            } else {
                userSelectContainer.classList.add('user-select-hidden');
                userSelectContainer.classList.remove('d-flex');
                generateBtn.disabled = true;
            }
        });
    } else {
        userSelectContainer.classList.add('user-select-hidden');
        userSelectContainer.classList.remove('d-flex');
        generateBtn.disabled = true;
    }
}